//一个具有启动、暂停、恢复和销毁能力的轮询（Polling）机制

export type PollingCallback = () => Promise<void>;

export class Polling {
  private intervalId: number | null;
  private interval: number;
  private callback: PollingCallback;
  private isPaused: boolean;
  private polingCount = 0;

  constructor(callback: PollingCallback, interval: number) {
    this.intervalId = null;
    this.interval = interval;
    this.callback = callback;
    this.isPaused = false;
  }

  start(): void {
    if (this.intervalId !== null) {
      console.log('轮询已经启动！');
      return;
    }

    this.isPaused = false;
    this.poll();
  }

  private poll(): void {
    this.intervalId = window.setInterval(async () => {
      if (!this.isPaused) {
        try {
          await this.callback();
          this.polingCount++;
        } catch (error) {
        }
      }
    }, this.interval);
  }

  pause(): void {
    if (this.intervalId === null) {
      console.log('轮询尚未启动！');
      return;
    }

    this.isPaused = true;
  }

  resume(): void {
    if (this.intervalId === null) {
      console.log('轮询尚未启动！');
      return;
    }

    if (!this.isPaused) {
      console.log('轮询未暂停！');
      return;
    }

    this.isPaused = false;
  }

  stop(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.polingCount = 0;
      this.intervalId = null;
    }
  }

  reset(): void {
    this.stop();
    this.start();
  }

  destroy(): void {
    this.stop();
    this.callback = async () => {};
  }

  getIntervalId(): any {
    return this.intervalId;
  }

  getPolingCount(): number {
    return this.polingCount;
  }

  isRunning(): boolean {
    return this.intervalId !== null && !this.isPaused;
  }
}
